import APIConnection from '@/api/APIConnection';
export default {
    login(data){
        var url = `${APIConnection.v2Url}/login`;
        return APIConnection.post(url,data,APIConnection.v2Interceptor);
    }
}